import { render, staticRenderFns } from "./Inmarsat.vue?vue&type=template&id=fb2ffbc8&scoped=true"
import script from "./Inmarsat.vue?vue&type=script&lang=js"
export * from "./Inmarsat.vue?vue&type=script&lang=js"
import style0 from "./Inmarsat.vue?vue&type=style&index=0&id=fb2ffbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2ffbc8",
  null
  
)

export default component.exports